import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { cpf } from 'cpf-cnpj-validator';
import { forkJoin, Subscription, tap } from 'rxjs';
import { generateUUID } from 'src/app/core/generators/generateUUID';
import { CarretaService } from 'src/app/services/CarretaService/carreta.service';
import { CavaloService } from 'src/app/services/CavaloService/cavalo.service';
import {
  ICreateMotorista,
  ICreateMotoristaEmpresa,
  IEditMotorista,
  IEditMotoristaEmpresa,
  IGetMotoristaById,
  IItems as IItemsMotorista
} from 'src/app/services/MotoristaService/motorista.model';
import { MotoristaService } from 'src/app/services/MotoristaService/motorista.service';
import { IGetServico } from 'src/app/services/ServicoService/servico.model';
import { ServicoService } from 'src/app/services/ServicoService/servico.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import Swal from 'sweetalert2';

type IOptions = {
  name: string;
  value: string | number;
};

@Component({
  selector: 'app-cadastro-motorista',
  templateUrl: './cadastro-motorista.component.html',
  styleUrls: ['./cadastro-motorista.component.scss']
})
export class CadastroMotoristaEmpresaComponent implements OnInit, OnDestroy {
  private subscription$ = new Subscription();
  form = this._inicializarFormulario();
  activeRoute: string = '';
  isEditing: boolean = false;
  isLoading: boolean = false;
  pkMotorista: number = 0;
  disabledMotorista: boolean = false;
  title: string = 'Cadastro Motorista';
  guid = generateUUID();

  servicoOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  motoristaOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  tipoCargaOptions: IOptions[] = [
    {
      name: 'Outros',
      value: 0
    },
    {
      name: 'Açúcar',
      value: 1
    },
    {
      name: 'Soja',
      value: 2
    },
    {
      name: 'Milho',
      value: 3
    },
    {
      name: 'Farelo',
      value: 4
    },
    {
      name: 'Adubo',
      value: 5
    },
    {
      name: 'Pó Rocha',
      value: 6
    },
    {
      name: 'Fosfato Calcio',
      value: 7
    },
    {
      name: 'Argila',
      value: 8
    },
    {
      name: 'Carvão Coque',
      value: 9
    },
    {
      name: 'Gesso',
      value: 10
    },
    {
      name: 'Cal',
      value: 11
    }
  ];

  tipoCarretaOptions: IOptions[] = [
    {
      name: 'Outros',
      value: 0
    },
    {
      name: 'Caçamba',
      value: 1
    },
    {
      name: 'Graneleiro',
      value: 2
    }
  ];

  carretaOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  cavaloOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private cd: ChangeDetectorRef,

    private servicoService: ServicoService,
    private motoristaService: MotoristaService,
    private cavaloService: CavaloService,
    private carretaService: CarretaService,
    private swalAlert: SwalAlertService
  ) {}

  createPayload(): ICreateMotoristaEmpresa | IEditMotoristaEmpresa {
    return {
      NM_USUA_MTRT: this.form.controls['NM_USUA_MTRT'].value,
      TX_CPF_MTRT: String(this.form.controls['TX_CPF_MTRT'].value),
      TX_CNH_MTRT: String(this.form.controls['TX_CNH_MTRT'].value),
      NU_TELE_MTRT: String(this.form.controls['NU_TELE_MTRT'].value),
      TX_MAIL_MTRT: String(this.form.controls['TX_MAIL_MTRT'].value),
      FK_EPSA: Number(this.form.controls['FK_EPSA'].value)
    };
  }

  private _inicializarFormulario() {
    const idEmpresa = localStorage.getItem('id') || '1';
    const form = this.fb.group({
      NM_USUA_MTRT: this.fb.control('', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      TX_CPF_MTRT: this.fb.control('', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      TX_CNH_MTRT: this.fb.control('', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      NU_TELE_MTRT: this.fb.control('', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      TX_MAIL_MTRT: this.fb.control('', {
        nonNullable: true,
        validators: [
          Validators.required,
          Validators.email,
          Validators.pattern(
            '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'
          )
        ]
      }),
      NU_STTS_MTRT: this.fb.control(1),
      FK_EPSA: this.fb.control(Number(idEmpresa))
    });
    return form;
  }
  obterDados() {
    this.subscription$.add(
      forkJoin([this.getServico(), this.getMotorista()]).subscribe(() => {
        this.route.queryParams.subscribe(params => {
          if (params && Object.keys(params).length > 0) {
            this.title = 'Editar Motorista';
            this.isEditing = true;
            this.disabledMotorista = false;
            this.motoristaService
              .GetMotoristaById(Number(params['codigo']))
              .subscribe((response: IGetMotoristaById) => {
                this.pkMotorista = response.PK_MTRT;
                this.form.controls['NM_USUA_MTRT'].setValue(
                  response.NM_USUA_MTRT ?? ''
                );
                this.form.controls['TX_CPF_MTRT'].setValue(
                  response.TX_CPF_MTRT ?? ''
                );
                this.form.controls['TX_CNH_MTRT'].setValue(
                  response.TX_CNH_MTRT ?? ''
                );
                this.form.controls['TX_MAIL_MTRT'].setValue(
                  response.TX_MAIL_MTRT ?? ''
                );
                this.form.controls['NU_TELE_MTRT'].setValue(
                  response.NU_TELE_MTRT ?? ''
                );
                this.form.controls['NU_STTS_MTRT'].setValue(
                  response.NU_STTS_MTRT ?? 1
                );
                this.form.controls['FK_EPSA'].setValue(response.FK_EPSA ?? 1);
              });

            if (params['modoMotorista'] == 'Visualizar') {
              this.title = 'Visualizar Motorista';
              this.form.disable();
              this.disabledMotorista = true;
            }
          }
        });
      })
    );
  }

  postarDados() {
    let payload: ICreateMotoristaEmpresa | IEditMotoristaEmpresa =
      this.createPayload();
    this.isLoading = true;
    if (!this.form.valid) {
      this.isLoading = false;
      this.swalAlert.showAlert(
        'Atenção!',
        'Verifique se todos os campos obrigatórios foram preenchidos corretamente.',
        'warning',
        false,
        false,
        undefined
      );

      return;
    }

    if (!cpf.isValid(String(this.form.controls.TX_CPF_MTRT.value))) {
      this.isLoading = false;

      this.swalAlert.showAlert(
        'Atenção!',
        'O CPF informado é inválido.',
        'warning',
        false,
        false,
        undefined
      );

      return;
    }

    if (this.title.includes('Editar')) {
      this.isEditing = true;
      this.isLoading = true;
      payload = {
        ...payload,
        NU_STTS_MTRT: 1
      };

      this.motoristaService
        .EditarMotorista(this.pkMotorista, payload)
        .subscribe(
          response => {
            this.isLoading = false;
            this.router.navigate(['empresa/listagem/motorista']);
          },
          error => {
            this.isLoading = false;
          }
        );
      return;
    }

    this.isEditing = false;
    this.motoristaService.CreateMotoristaEmpresa(payload, this.guid).subscribe(
      response => {
        this.isLoading = false;
        this.router.navigate(['empresa/listagem/motorista']);
      },
      error => {
        this.isLoading = false;
      }
    );
  }

  getServico() {
    this.isLoading = true;
    return this.servicoService.GetServico().pipe(
      tap(response => {
        this.isLoading = false;
        this.servicoOptions = response.map((x: IGetServico) => {
          return {
            name: x.TX_TIPO_SRVC,
            value: x.PK_SRVC
          };
        });
      })
    );
  }

  getMotorista() {
    this.isLoading = true;
    return this.motoristaService.GetMotoristaEmpresa({ paginar: false }).pipe(
      tap(response => {
        this.isLoading = false;
        this.motoristaOptions = response.ITEMS.map((x: IItemsMotorista) => {
          return {
            name: x.NM_USUA_MTRT,
            value: x.PK_MTRT
          };
        });
      })
    );
  }

  exibirMensagem(mensagem: string, type: 'success' | 'error') {
    const config: MatSnackBarConfig = {
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: type === 'success' ? ['snackbar-success'] : ['snackbar-error']
    };

    this.snackBar.open(mensagem, 'Fechar', config);
  }

  public goTo(route: string) {
    this.router.navigate([route]);
    setTimeout(() => {
      this.activeRoute = this.router.url;
      this.cd.detectChanges();
    }, 200);
  }

  ngOnInit(): void {
    this.obterDados();
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }
}
